import { Component } from "@theme/component";
import { fetchConfig, onAnimationEnd, preloadImage } from "@theme/utilities";
import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from "@theme/events";
import { cartPerformance } from "@theme/performance";
import { morph } from "@theme/morph";
export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2e3;
export class AddToCartComponent extends Component {
    requiredRefs = ["addToCartButton"];
    #t;
    #e;
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("pointerenter", this.#o);
    }
    disconnectedCallback() {
        super.disconnectedCallback(),
            this.#t && clearTimeout(this.#t),
            this.#e && clearTimeout(this.#e),
            this.removeEventListener("pointerenter", this.#o);
    }
    disable() {
        this.refs.addToCartButton.disabled = !0;
    }
    enable() {
        this.refs.addToCartButton.disabled = !1;
    }
    handleClick(t) {
        const e = this.closest("form");
        if (!e?.checkValidity()) return;
        this.animateAddToCart();
        "true" === this.dataset.addToCartAnimation && !t.target.closest(".quick-add-modal") && this.#s();
    }
    #o = () => {
        const t = this.dataset.productVariantMedia;
        t && preloadImage(t);
    };
    #s() {
        const { addToCartButton: t } = this.refs,
            e = document.querySelector(".header-actions__cart-icon"),
            o = this.dataset.productVariantMedia;
        if (!e || !t || !o) return;
        const s = document.createElement("fly-to-cart");
        s.style.setProperty("background-image", `url(${o})`),
            (s.source = t),
            (s.destination = e),
            document.body.appendChild(s);
    }
    animateAddToCart() {
        const { addToCartButton: t } = this.refs;
        this.#t && clearTimeout(this.#t),
            this.#e && clearTimeout(this.#e),
            t.classList.contains("atc-added") || t.classList.add("atc-added"),
            (this.#t = setTimeout(() => {
                this.#e = setTimeout(() => {
                    this.refs.addToCartButton.classList.remove("atc-added");
                }, 10);
            }, 2e3));
    }
}
customElements.get("add-to-cart-component") || customElements.define("add-to-cart-component", AddToCartComponent);
class ProductFormComponent extends Component {
    requiredRefs = ["variantId", "liveRegion"];
    #a = new AbortController();
    #n;
    connectedCallback() {
        super.connectedCallback();
        const { signal: t } = this.#a,
            e = this.closest(".shopify-section, dialog, product-card");
        e?.addEventListener(ThemeEvents.variantUpdate, this.#i, { signal: t }),
            e?.addEventListener(ThemeEvents.variantSelected, this.#r, { signal: t });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.#a.abort();
    }
    handleSubmit(t) {
        const { addToCartTextError: e } = this.refs;
        if (
            (t.preventDefault(),
            this.#n && clearTimeout(this.#n),
            "true" === this.refs.addToCartButtonContainer?.refs.addToCartButton?.getAttribute("disabled"))
        )
            return;
        const o = this.querySelector("form");
        if (!o) throw new Error("Product form element missing");
        const s = new FormData(o),
            a = document.querySelectorAll("cart-items-component");
        let n = [];
        a.forEach((t) => {
            t instanceof HTMLElement && t.dataset.sectionId && n.push(t.dataset.sectionId),
                s.append("sections", n.join(","));
        });
        const i = fetchConfig("javascript", { body: s });
        fetch(Theme.routes.cart_add_url, { ...i, headers: { ...i.headers, Accept: "text/html" } })
            .then((t) => t.json())
            .then((t) => {
                if (t.status) {
                    if (
                        (this.dispatchEvent(
                            new CartErrorEvent(o.getAttribute("id") || "", t.message, t.description, t.errors)
                        ),
                        !e)
                    )
                        return;
                    e.classList.remove("hidden");
                    const a = e.childNodes[2];
                    if (a) a.textContent = t.message;
                    else {
                        const o = document.createTextNode(t.message);
                        e.appendChild(o);
                    }
                    return (
                        this.#c(t.message),
                        (this.#n = setTimeout(() => {
                            e && (e.classList.add("hidden"), this.#d());
                        }, 1e4)),
                        void this.dispatchEvent(
                            new CartAddEvent({}, this.id, {
                                didError: !0,
                                source: "product-form-component",
                                itemCount: Number(s.get("quantity")) || Number(this.dataset.quantityDefault),
                                productId: this.dataset.productId,
                            })
                        )
                    );
                }
                {
                    const o = s.get("id");
                    if ((e && (e.classList.add("hidden"), e.removeAttribute("aria-live")), !o))
                        throw new Error("Form ID is required");
                    if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
                        const t =
                                this.refs.addToCartButtonContainer.refs.addToCartButton.querySelector(
                                    ".add-to-cart-text--added"
                                ),
                            e = t?.textContent?.trim() || Theme.translations.added;
                        this.#c(e),
                            setTimeout(() => {
                                this.#d();
                            }, 5e3);
                    }
                    this.dispatchEvent(
                        new CartAddEvent({}, o.toString(), {
                            source: "product-form-component",
                            itemCount: Number(s.get("quantity")) || Number(this.dataset.quantityDefault),
                            productId: this.dataset.productId,
                            sections: t.sections,
                        })
                    );
                }
            })
            .catch((t) => {
                console.error(t);
            })
            .finally(() => {
                cartPerformance.measureFromEvent("add:user-action", t);
            });
    }
    #c(t) {
        this.refs.liveRegion.textContent = t;
    }
    #d() {
        this.refs.liveRegion.textContent = "";
    }
    #i = (t) => {
        if (t.detail.data.newProduct) this.dataset.productId = t.detail.data.newProduct.id;
        else if (t.detail.data.productId !== this.dataset.productId) return;
        const { variantId: e, addToCartButtonContainer: o } = this.refs,
            s = o?.refs.addToCartButton,
            a = t.detail.data.html.querySelector('[ref="addToCartButton"]');
        if (
            s &&
            (null == t.detail.resource || 0 == t.detail.resource.available
                ? (o.disable(), this.refs.acceleratedCheckoutButtonContainer?.setAttribute("hidden", "true"))
                : (o.enable(), this.refs.acceleratedCheckoutButtonContainer?.removeAttribute("hidden")),
            a && morph(s, a),
            (e.value = t.detail.resource.id ?? ""),
            t.detail.resource)
        ) {
            const e = t.detail.resource.featured_media?.preview_image?.src;
            e && o?.setAttribute("data-product-variant-media", e + "&width=100");
        }
    };
    #r = () => {
        this.refs.addToCartButtonContainer?.disable();
    };
}
customElements.get("product-form-component") || customElements.define("product-form-component", ProductFormComponent);